import { formatDateTimeSecond,formatDateTime, formatDate } from '../utils/dates';
import NotificationMixin from './NotificationMixin';
import { mapActions, mapState } from 'vuex';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      options: {
        sortBy: ['id'],
        sortDesc: [true],
        descending: false,
        page: 1,
        itemsPerPage: 15,
        pagination: true
      },
      filters: {},
      footer: {
        'itemsPerPageText': "",
        'items-per-page-options':[5,10,15,50,100,-1],
      },
      ...mapState(['allIds']),
    };
  },

  watch: {
    deletedItem(item) {
      if (item['name']) {
        this.showMessage(`${item['name']} ${this.$t('global.deleted')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.deleted')}`);
      }
    },

    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        if(this.$route.name != 'RegenPassword') this.$router.push({ name: `Login` });
      }else {
        message && this.showError(message);
      }
    },

    items() {
      this.options.totalItems = this.totalItems;
    }
  },

  methods: {
    onUpdateOptions(props) {

      this.resetList = true;
      const { page, itemsPerPage, sortBy, descending, totalItems, pagination } = props;
      let filters = {
        ...this.filters
      };
      let params = {
      };
      //transform name filter _before and _after to [before] and [after] and _exists to exists[value]=true
      for (var property in filters) {
  
        var value = filters[property];
        if (Array.isArray(value)) {
          if (value.length > 0) {
            if (value[0]['@id']) {
              var arrayTemp = [];
              for (var subvalue of value) {
                if (subvalue['@id']) {
                  arrayTemp.push(subvalue['@id']);
                }            
              }
              value = arrayTemp;
            }
          }
        }
        if (typeof value === 'object') {
          if (value['@id']) {
            value = value['@id'];
          }
        }
        var key = property.replaceAll('_before', '[strictly_before]').replaceAll('_after', '[strictly_after]').replaceAll('_sub_', '.');
        key = key.replaceAll('_gte', '[gte]').replaceAll('_lte', '[lte]');
        if (key == '_exists') {
          key= 'exists['+value+']';
          value = true;
        }
        params[key] = value;
      }

      if (itemsPerPage > 0) {
        params = { ...params, itemsPerPage, page };
      }
      if (itemsPerPage == -1) {
        //1000 max pour ne pas surcharger l'api
        params[`page`] = 1;
        params[`itemsPerPage`] = 1000;
      }
      if (!pagination) {
        params[`pagination`] = false;
      }
      if (sortBy) {
        for (var i = 0; i < sortBy.length; i++) {
          if (this.options.sortDesc[i]) {
            params[`order[${sortBy[i]}]`] = 'desc';
          } else {
            params[`order[${sortBy[i]}]`] ='asc';
          }
        }
      }
      //console.log(this.items);
      this.getPage(params).then(() => {
        this.options.sortBy = sortBy;
        this.options.descending = descending;
        this.options.itemsPerPage = itemsPerPage;
        this.options.totalItems = totalItems;
        this.options.pagination = pagination;
      });
      //console.log(this.items);
    },

    onSendFilter() {
      this.options.page = 1;
      this.onUpdateOptions(this.options);
    },

    resetFilter() {
      this.filters = {};
      this.onUpdateOptions(this.options);
    },

    addHandler() {
      this.$router.push({ name: `${this.$options.servicePrefix}Create` });
    },
    addHandlerSub(name,item) {
      this.$router.push({
        name: `${name}Create`,
        params: { parent: item['@id'] }
      });
    },
    showHandler(item) {
      this.$router.push({
        name: `${this.$options.servicePrefix}Show`,
        params: { id: item['@id'] }
      });
    },
    showHandlerExt(event, item) {
      let routeData = this.$router.resolve({
        name: `${this.$options.servicePrefix}Show`,
        params: { id: item.item['@id'] }
      });
      window.open(routeData.href, '_blank');
      event.preventDefault()
    },
    showHandlerSub(item,name,itemSub) {
      if (itemSub) {
        this.$router.push({
          name: `${name}Show`,
          params: { parent: item['@id'] , id: itemSub['@id']}
        });
      } else {
        this.$router.push({
          name: `${item['@type']}Show`,
          params: { id: item['@id']}
        });
      }
    },
    showHandlerSubExt(event,item,name,itemSub) {
      let routeData = null;
      if (itemSub) {
        routeData = this.$router.resolve({
          name: `${name}Show`,
          params: { parent: item.item['@id'] , id: itemSub['@id']}
        });
      } else {
        routeData = this.$router.resolve({
          name: `${item.item['@type']}Show`,
          params: { id: item.item['@id']}
        });
      }
      window.open(routeData.href, '_blank');
      event.preventDefault()
    },
    editHandler(item) {
      this.$router.push({
        name: `${this.$options.servicePrefix}Update`,
        params: { id: item['@id'] }
      });
    },
    editHandlerSub(item,name,itemSub) {
      this.$router.push({
        name: `${name}Update`,
        params: { parent: item['@id'] , id: itemSub['@id']}
      });
    },

    deleteHandler(item) {
      this.deleteItem(item).then(() => this.onUpdateOptions(this.options));
    },
    downloadHandler(item) {
      this.mediaobjectPushDownload({ 'id' : item['@id'], 'name' : item['filePath'] });
    },
    formatDateTime,
    formatDate,
    formatDateTimeSecond,
    ...mapActions({
      mediaobjectPushDownload: 'mediaobject/download'
    }),
  }
};
